module.exports = __webpack_public_path__ + "img/蒲黄.3c9dc905.jpg";